import { hasCode } from './check-error';
import toast from './toast';

export function showMessageBadRequestError(error: unknown, referMessage: Record<string, string>) {
  if (hasCode(error)) {
    const message = referMessage[error.code];
    message && toast.error(message);
  }
}
